import {
    faBell,
    faCircleHalfStroke,
    faEnvelope,
    faGavel,
    faGear,
    faMoon,
    faRightFromBracket,
    faSun,
    faUser,
    faVial,
    faWrench,
} from '@fortawesome/pro-solid-svg-icons';
import { withTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import faAppflowy from '../Icons/faAppflowy';
import faDynamicEarth from '../Icons/faDynamicEarth';
import ActionsMenu from './ActionsMenu';

const UserMenu = ({
    t,
    contestsToJudge = [],
    darkModeStatus,
    allowedActions = [],
    isOpened,
    onLanguageChange = () => { },
    onThemeChange = () => { },
    onClose = () => { },
    onSignOut = () => { },
    user = null,
    unreadChats = null,
    unreadNotifications = null,
    ...rest
}) => {
    const navigate = useNavigate();

    return <ActionsMenu {...rest} isOpened={isOpened} onClose={onClose} actions={[
        { action: `/users/${user.id}/${user.slug}`, icon: faUser, title: t('My profile') },
        { action: `/users/${user.id}/${user.slug}/edit`, icon: faGear, title: t('Settings') },
        { type: 'DIVIDER' },
        ...(user && (unreadChats !== null || unreadNotifications !== null) ? [
            ...(unreadNotifications !== null ? [{ type: unreadNotifications ? 'ALERT' : 'NORMAL', action: () => navigate(`/notifications/?t=${new Date().getTime()}`), icon: faBell, title: t('Notifications ({{nb}})', { nb: unreadNotifications }) }] : []),
            ...(unreadChats !== null ? [{ type: unreadChats ? 'ALERT' : 'NORMAL', action: `/chats/`, icon: faEnvelope, title: t('Chats ({{nb}})', { nb: unreadChats }) }] : []),
            { type: 'DIVIDER' },
        ] : []),
        { action: onLanguageChange, icon: faDynamicEarth, title: t('Language') },
        ...(darkModeStatus === 'LIGHT' ? [{ action: () => onThemeChange('DARK'), icon: faSun, title: t('Light theme') }] : []),
        ...(darkModeStatus === 'DARK' ? [{ action: () => onThemeChange('AUTO'), icon: faMoon, title: t('Dark theme') }] : []),
        ...(darkModeStatus === 'AUTO' ? [{ action: () => onThemeChange('LIGHT'), icon: faCircleHalfStroke, title: t('Auto theme') }] : []),
        { type: 'DIVIDER' },
        ...contestsToJudge.map(contest => ({ action: `/contests/${contest.id}/judge/${user.id}`, icon: faGavel, title: contestsToJudge.length > 1 ? t('Judge ({{title}})', { title: contest.shortTitle }) : t('Judge contest') })),
        ...(contestsToJudge.length > 0 ? [{ type: 'DIVIDER' }] : []),
        ...(!user.isPremium ? [{ action: `/offers/`, title: t('Become premium'), type: 'PREMIUM' }] : []),
        ...(allowedActions?.includes('ACCESS_EXPERIMENTAL_FEATURES') ? [{ action: `/experimental/`, icon: faVial, title: t('Experimental features') }] : []),
        ...(allowedActions?.includes('ADMIN_APPFLOWY') ? [{ action: `/admin/appflowy`, icon: faAppflowy, title: t('Appflowy') }] : []),
        ...(allowedActions.some(e => e.startsWith('ADMIN_')) || allowedActions.includes('READ_DRAFT_ARTICLES') ? [{ action: `/admin/`, icon: faWrench, title: t('Admin') }] : []),
        { type: 'DIVIDER' },
        { action: onSignOut, icon: faRightFromBracket, title: t('Sign out'), type: "LOGOUT" },
    ]} />
};

export default withTranslation()(UserMenu);
